import type { FaireProductEntity } from "../../entity_types/product";

export const p_52ghyvggxh: FaireProductEntity = {
  token: "p_52ghyvggxh",
  type: "product",
  name: "Relaxation Spa Gift Set with Candle, Soap, Bath Bomb",
  brandName: "Natural Amor LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/a1cb6d4b964b6a681b24dfc0cb690bd561baf910b71664f3f81ab540ebf3a521.jpeg",
  priceDollars: 18,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/fb7ac7bf24b14c7673e7964d14d96b5296394802c65f3cf4f0e8e0f446609e42.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
